import { ref, watch } from 'vue';
import { getCities, getStates } from 'shared/helpers/locationData';

/**
 * Opções de estado (do país escolhido) e de cidade (do estado escolhido).
 * Recebe funções que devolvem o código do país e a sigla do estado atuais.
 * Lista vazia e sem carregamento significa que não há dados para aquele país ou estado.
 */
export function useLocationOptions(getCountryCode, getStateCode) {
  const stateOptions = ref([]);
  const cityOptions = ref([]);
  const loadingStates = ref(false);
  const loadingCities = ref(false);

  watch(
    getCountryCode,
    async countryCode => {
      stateOptions.value = [];
      loadingStates.value = !!countryCode;
      if (!countryCode) return;

      const states = await getStates(countryCode);
      // Se o país mudou durante a busca, a resposta mais nova é quem atualiza a lista.
      if (getCountryCode() !== countryCode) return;
      stateOptions.value = states;
      loadingStates.value = false;
    },
    { immediate: true }
  );

  // Só busca cidades de uma sigla que existe na lista do país: texto livre não dispara busca.
  watch(
    [getCountryCode, getStateCode, stateOptions],
    async ([countryCode, stateCode, states]) => {
      cityOptions.value = [];
      const known = states.some(({ value }) => value === stateCode);
      loadingCities.value = false;
      if (!countryCode || !stateCode || !known) return;

      loadingCities.value = true;
      const cities = await getCities(countryCode, stateCode);
      if (getCountryCode() !== countryCode || getStateCode() !== stateCode) {
        return;
      }
      cityOptions.value = cities;
      loadingCities.value = false;
    },
    { immediate: true }
  );

  return { stateOptions, cityOptions, loadingStates, loadingCities };
}
